export default __webpack_public_path__ + "static/media/youtube.bc069a2b.png";